export default __webpack_public_path__ + "files/9aca26190279b3343d86451ecd3527f0.mp3";